// CMS entries for dfsweb-rewamp-agri-input override these at runtime.
export const en = {
  "AGRI_INPUT_FILTER.PRICE": "Price",
  "AGRI_INPUT_FILTER.CATEGORY": "Category",
  "AGRI_INPUT_FILTER.SUB_CATEGORY": "Sub Category",
  "AGRI_INPUT_FILTER.BRAND": "Brands",
  "AGRI_INPUT_FILTER.SELECT": "Select",
  "AGRI_INPUT_FILTER.ADJUST_PRICE_RANGE": "Adjust Price Range",
  "AGRI_INPUT_PAGE.TITLE": "Agri Input Market Place",
  "AGRI_INPUT_PAGE.SHOP_BY_CATEGORY": "Shop By Category",
  "AGRI_INPUT_PAGE.SHOP_BY_BRANDS": "Shop By Brands",
  "AGRI_INPUT_PAGE.LIKED_PRODUCTS": "Favourites",
  "AGRI_INPUT_PAGE.TRENDING_PRODUCTS": "Trending Products",
  "AGRI_INPUT_PAGE.NO_PRODUCTS_FOUND": "No products found",
  "AGRI_INPUT_SEARCH.PLACEHOLDER": "Search",
  "AGRI_INPUT_SEARCH.INVALID_RESULT": "The product link is invalid or has expired.",
  "AGRI_INPUT_CARD.DISCOUNT_OFF": "{{percent}}% OFF",
  "AGRI_INPUT_CARD.ADD_TO_WISHLIST": "Add to wishlist",
  "AGRI_INPUT_CARD.REMOVE_FROM_WISHLIST": "Remove from wishlist",
  "AGRI_INPUT_CARD.RATING_LABEL": "Rated {{rating}} out of 5, {{count}} reviews",
  "AGRI_INPUT_CARD.SOLD_BY": "Sold by {{shop}}",
  "AGRI_INPUT_CARD.SELECT_PACK_SIZE": "Select pack size",
  "AGRI_INPUT_CARD.WAS_PRICE_PREFIX": "was",
  "AGRI_INPUT_CARD.BUY": "Buy",
  "AGRI_INPUT_REDIRECT.TITLE": "You are being redirected to {{shop}}",
  "AGRI_INPUT_REDIRECT.SHOP_FALLBACK": "the shop",
  "AGRI_INPUT_REDIRECT.DESCRIPTION": "You will now leave the app and be taken to the seller’s website to complete your purchase.",
  "AGRI_INPUT_BRANDS.CAROUSEL": "Brands Carousel",
  "AGRI_INPUT_FILTER.ARIA": "Filter products",
  "AGRI_INPUT_PACK_DIALOG.CHOOSE_SIZE": "Choose a Size",
  "AGRI_INPUT_DETAILS.CHOOSE_PACK_SIZE": "Choose Pack Size:",
  "AGRI_INPUT_DETAILS.BRAND_LABEL": "Brand :",
  "AGRI_INPUT_DETAILS.SOLD_BY_LABEL": "Sold by",
  "AGRI_INPUT_DETAILS.HEADING": "Details",
  "AGRI_INPUT_DETAILS.PRODUCT_NOT_FOUND": "Product not found.",
  "AGRI_INPUT_BRANDS.NO_BRANDS_FOUND": "No brands found",
  "AGRI_INPUT_BRANDS.CATEGORY_TABS": "Filter brands by category",
  "AGRI_INPUT_BRANDS.TOP_BRANDS_TAB": "Top brands",
  "AGRI_INPUT_PAGE.ALL_BRANDS" : "All brands"
};

export const hi = {
  "AGRI_INPUT_FILTER.PRICE": "मूल्य",
  "AGRI_INPUT_FILTER.CATEGORY": "श्रेणी",
  "AGRI_INPUT_FILTER.SUB_CATEGORY": "उप-श्रेणी",
  "AGRI_INPUT_FILTER.BRAND": "ब्रांड",
  "AGRI_INPUT_FILTER.SELECT": "चुनें",
  "AGRI_INPUT_FILTER.ADJUST_PRICE_RANGE": "मूल्य सीमा समायोजित करें",
  "AGRI_INPUT_PAGE.TITLE": "कृषि इनपुट बाज़ार",
  "AGRI_INPUT_PAGE.SHOP_BY_CATEGORY": "श्रेणी के अनुसार खरीदें",
  "AGRI_INPUT_PAGE.SHOP_BY_BRANDS": "ब्रांड के अनुसार खरीदें",
  "AGRI_INPUT_PAGE.LIKED_PRODUCTS": "पसंदीदा",
  "AGRI_INPUT_PAGE.TRENDING_PRODUCTS": "ट्रेंडिंग उत्पाद",
  "AGRI_INPUT_PAGE.NO_PRODUCTS_FOUND": "कोई उत्पाद नहीं मिला",
  "AGRI_INPUT_SEARCH.PLACEHOLDER": "खोजें",
  "AGRI_INPUT_SEARCH.INVALID_RESULT": "उत्पाद लिंक अमान्य है या समाप्त हो गया है।",
  "AGRI_INPUT_CARD.DISCOUNT_OFF": "{{percent}}% छूट",
  "AGRI_INPUT_CARD.ADD_TO_WISHLIST": "पसंदीदा में जोड़ें",
  "AGRI_INPUT_CARD.REMOVE_FROM_WISHLIST": "पसंदीदा से हटाएँ",
  "AGRI_INPUT_CARD.RATING_LABEL": "रेटिंग {{rating}} में से 5, {{count}} समीक्षाएँ",
  "AGRI_INPUT_CARD.SOLD_BY": "विक्रेता {{shop}}",
  "AGRI_INPUT_CARD.SELECT_PACK_SIZE": "पैक साइज़ चुनें",
  "AGRI_INPUT_CARD.WAS_PRICE_PREFIX": "पहले",
  "AGRI_INPUT_CARD.BUY": "खरीदें",
  "AGRI_INPUT_REDIRECT.TITLE": "आपको {{shop}} पर भेजा जा रहा है",
  "AGRI_INPUT_REDIRECT.SHOP_FALLBACK": "दुकान",
  "AGRI_INPUT_REDIRECT.DESCRIPTION": "अब आप ऐप से बाहर जाकर खरीदारी पूरी करने के लिए विक्रेता की वेबसाइट पर पहुँचेंगे।",
  "AGRI_INPUT_BRANDS.CAROUSEL": "ब्रांड कैरोसेल",
  "AGRI_INPUT_FILTER.ARIA": "उत्पाद फ़िल्टर करें",
  "AGRI_INPUT_PACK_DIALOG.CHOOSE_SIZE": "एक साइज़ चुनें",
  "AGRI_INPUT_DETAILS.CHOOSE_PACK_SIZE": "पैक साइज़ चुनें:",
  "AGRI_INPUT_DETAILS.BRAND_LABEL": "ब्रांड :",
  "AGRI_INPUT_DETAILS.SOLD_BY_LABEL": "विक्रेता",
  "AGRI_INPUT_DETAILS.HEADING": "विवरण",
  "AGRI_INPUT_DETAILS.PRODUCT_NOT_FOUND": "उत्पाद नहीं मिला।",
  "AGRI_INPUT_BRANDS.NO_BRANDS_FOUND": "कोई ब्रांड नहीं मिला",
  "AGRI_INPUT_BRANDS.CATEGORY_TABS": "श्रेणी के अनुसार ब्रांड फ़िल्टर करें",
  "AGRI_INPUT_BRANDS.TOP_BRANDS_TAB": "शीर्ष ब्रांड",
  "AGRI_INPUT_PAGE.ALL_BRANDS": "सभी ब्रांड"
};
